import "slick-carousel";
import "fslightbox";

(function($) {
	$(document).ready(function () {
		subscribeNewsletter();
		mobileMenu();
		openSearchForm();
		defaultGalleryLightbox();
		initMap();
		initModal();
		initProductGallery();
		mobileSubMenus();

		if ($('.site').hasClass('front-page')) {
			$(window).scroll(function() {
				let scroll = $(window).scrollTop();

				if (scroll >= 10) {
					$('body').addClass('sticky');
				}
				else {
					$('body').removeClass('sticky');
				}
			});
		} else {
			$('body').addClass('sticky');
		}


		$('.go-bottom').click(function () {
				let nextElement = $(this).parents('.slider').next('.section');
				if (nextElement)
				{
					$([document.documentElement, document.body]).animate({
						scrollTop: nextElement.offset().top - 120
					}, 200);
				}
		});

		if ($('.slider').length) {
			$('.slider .slides').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoPlay: true,
				arrows: true,
				dots: true,
				appendDots: $('.slider .slide-dots'),
				prevArrow: $('.slider .slide-prev'),
				nextArrow: $('.slider .slide-next'),
				lazyLoad: true
			});
		}

		if ($('.projects-slider').length) {
			$('.projects-slides').slick({
				infinite: false,
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				prevArrow: $('.projects-slider .slide-prev'),
				nextArrow: $('.projects-slider .slide-next'),
				variableWidth: true,
				lazyLoad: true,
				responsive: [
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 1,
							variableWidth: false
						}
					},
				]
			});
		}

		if ($('.news-slider').length) {
			$('.news-slides').slick({
				infinite: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				prevArrow: $('.news-slider .slide-prev'),
				nextArrow: $('.news-slider .slide-next'),
				lazyLoad: true,
				responsive: [
					{
						breakpoint: 1380,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});
		}

		$('.search-form-wrapper').focusout(function () {
			$(this).parent().removeClass('active');
		})

		function subscribeNewsletter()
		{
			$('#newsletterForm').submit(function (e) {
				e.preventDefault();
				let form = $(this);
				let btn = $(this).find('button');
				btn.addClass('loading').attr('disabled', true);
				$.ajax({
					data: {
						action: 'subscribeNewsletter',
						email: $('#newsletterForm input[name="email"]').val(),
					},
					type: 'POST',
					url: ajax_object.ajaxurl,
					success: function(response) {
						btn.removeClass('loading').attr('disabled', false);
						if (response.success) {
							form.parent().html(`<h5 class="pb-0">${response.data.message}</h5>`);
							$('.footer-media').addClass('success');
						} else {
							form.find('.with-errors').removeClass('with-errors');
							form.find('.field-group__errors').remove();

							let input = form.find(`input[name='email']`);
							input.parents('.field-group').addClass('with-errors');
							input.parents('.field-group__fields').append(`<div class="field-group__errors">${response.data.message}</div>`);
						}
					},
					error: function () {

					}
				});
			});
		}

		function mobileMenu()
		{
			$('.mobile-menu-open').click(function () {
				$('body').toggleClass('show-menu');
			});
		}

		function openSearchForm()
		{
			$('.search-wrapper .search-btn').click(function () {
				let parent = $(this).parent();
				parent.toggleClass('show-search');

				if (parent.hasClass('show-search')) {
					setTimeout(function(){
						parent.find('.search-form .search-field')[0].focus();
					}, 100);
				}
			})
		}

		function defaultGalleryLightbox()
		{
				if (typeof refreshFsLightbox === "function")
				{
					let gallery = document.querySelectorAll('.wp-block-gallery img');
					gallery.forEach(function(galleryItem)
					{
						let src = galleryItem.getAttribute("data-full-url");
						let href = document.createElement('a');
						href.setAttribute("href", src);
						href.setAttribute("data-fslightbox", 'galerija');

						galleryItem.parentNode.insertBefore(href, galleryItem);
						href.appendChild(galleryItem);
					});

					refreshFsLightbox();
				}
		}

		function initModal()
		{
			$('*[data-modal]').click(function (e) {
				e.preventDefault();
				let target = $(this).attr('data-modal');

				$('#'+target).fadeIn();
			});

			$('.modal-close').click(function (e) {
				$(this).closest('.modal').fadeOut();
			});
		}

		function initMap()
		{
				let mapDiv = document.getElementById('map');

				if (mapDiv != null) {
					let elMap = $('#map');

					let latitude = elMap.data('lat');
					let longitude = elMap.data('lng');
					let markerText = elMap.data('marker');

					let map = L.map(mapDiv, {
						zoom: 3,
						zoomControl: false,
						dragging: false,
						pan: false,
						doubleClickZoom: false,
						scrollWheelZoom: false
					}).setView({lat: latitude, lng: longitude}, 13);

					L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
						attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
						maxZoom: 18,
						id: 'mapbox/light-v10',
						tileSize: 512,
						zoomOffset: -1,
						accessToken: 'pk.eyJ1IjoibWV0YWxiZXRhIiwiYSI6ImNsbHhkN2phejBrNWgzY3N5cnA2eXhuY2gifQ.T6EZ4Pf-mFpR0ryEB8PGpw'
					}).addTo(map);

					L.marker([latitude, longitude], {
						icon: new L.DivIcon({
							html: `<div class="map-marker">${markerText}</div>`,
							iconSize: null
						})
					}).addTo(map);

					$(document).click(function (e) {
						if (e.target instanceof HTMLElement && !document.querySelector('#map').contains(e.target)) {
							elMap.removeClass('allow-zoom');
							map.scrollWheelZoom.disable();
							map.doubleClickZoom.disable();
							map.dragging.disable();
						}
					});

					elMap.click(function () {
						elMap.addClass('allow-zoom');
						map.scrollWheelZoom.enable();
						map.doubleClickZoom.enable();
						map.dragging.enable();
					});

					elMap.mouseover(function () {
						if (!elMap.hasClass('allow-zoom')) {
							elMap.addClass('mouse-enter');
						}
					});

					elMap.mouseout(function () {
						elMap.removeClass('mouse-enter');
					});
				}
		}

		function initProductGallery()
		{
			$('.product-gallery-item').click(function () {
				$('.product-gallery-item').removeClass('active');
				$(this).addClass('active');

				$('.product-gallery-image').hide();
				$('.product-gallery-image').eq($(this).index()).css('display', 'block');
			});
		}

		function mobileSubMenus()
		{
			$('#primary-menu-mob .current-menu-ancestor').addClass('active');
			let toggleSubMenu = $('<div class="toggle-sub-menu"></div>');
			toggleSubMenu.click(function () {
				$(this).parent().toggleClass('active');
				$(this).siblings('.sub-menu').slideToggle();
			});

			$('#primary-menu-mob > li.menu-item-has-children').each(function () {
				if ($(this).find('> .toggle-sub-menu').length < 1) {
					$(this).find('a').after(toggleSubMenu);
				}
			});
		}
	});
})(jQuery);
